import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { InternalUserResponseDto, UserCreateDto } from '../dtos/internal-user.dto';
import { RoleResponseDto } from '../dtos/role.dto';

@Injectable({
    providedIn: 'root'
})
export class InternalUsersService {
    private readonly GET = environment.outgoingRequestAPI + 'User/all/internal';
    private readonly GET_ROLE = environment.outgoingRequestAPI + 'User/roles';
    private readonly UPDATE = environment.outgoingRequestAPI + 'User';

    public constructor(private http: HttpClient) { }

    public getUsers(): Observable<InternalUserResponseDto> {
        return this.http.get<InternalUserResponseDto>(this.GET);
    }

    public addNewUser(user: UserCreateDto): Observable<InternalUserResponseDto> {
        return this.http.post<InternalUserResponseDto>(this.UPDATE, { requestData: user });
    }

    public updateUser(user: UserCreateDto): Observable<InternalUserResponseDto> {
        return this.http.put<InternalUserResponseDto>(this.UPDATE, { requestData: user });
    }

    public updateUsersStatus(id: number, enabled: boolean): Observable<InternalUserResponseDto> {
        return this.http.put<InternalUserResponseDto>(`${this.UPDATE}/${id}/status/${enabled}`, {});
    }

    public deleteUser(id: number): Observable<InternalUserResponseDto> {
        return this.http.delete<InternalUserResponseDto>(`${this.UPDATE}/${id}`);
    }

    public getRoles(): Observable<RoleResponseDto> {
        return this.http.get<RoleResponseDto>(this.GET_ROLE);
    }
}
